/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
// eslint-disable-next-line no-useless-escape
import eventDispatcher from '../events/dispatch';
import { dataIdSvcErrorDict } from '../components/mediaManager/sheetConfigs';
import format from 'date-fns/format';

const DISCOVER_BUNDLES = {
  V2: 'v2',
  V1: 'v1-int-bundle',
  V0: 'v0-beta',
};

const ATTACH_HOSTS = {
  current: {
    local: 'http://localhost:3000',
    staging: 'https://attach-dev.mikmak.tv',
    stagingV2: 'https://mikmak-attach-search-dev.herokuapp.com', // heroku server attach
    production: 'https://attach.mikmak.tv',
    productionV2: 'https://shop.mikmak.com', // heroku server attach
  },
};

const EMBED_HOSTS = {
  current: {
    development: 'https://mikmak-embed-dev.herokuapp.com',
    production: 'https://mikmak-embed-prod.herokuapp.com',
  },
};

const PRODUCT_SERVICE_HOSTS = {
  staging: 'https://mikmak-product-service-dev.appspot.com',
  production: 'https://useful-builder-219815.appspot.com',
};

const PRODUCT_SEARCH_HOSTS = {
  staging: 'https://product-search-dev-dot-mikmak-product-service-dev.ue.r.appspot.com',
  production: 'https://product-search-dot-useful-builder-219815.ue.r.appspot.com',
};

const FIREBASE_SERVICE_HOSTS = {
  development: 'https://dev-dot-mikmak-firebase-service.ue.r.appspot.com',
  feature: 'https://feature-dot-mikmak-firebase-service.ue.r.appspot.com',
  production: 'https://mikmak-firebase-service.ue.r.appspot.com',
  local: 'http://localhost:5000',
};

const AVAILABILITY_URL = {
  production: 'https://shop.mikmak.tv/api/availability',
  staging: 'https://shop.mikmak.tv/api/availability-dev',
};

const SALES_DATA_SERVICE_URL = {
  production: '/api/v1/salesDataService',
  local: 'http://localhost:8080/api/v1/salesDataService',
};

const firebaseProxyUrl =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8080/api/v1/firebaseServiceProxy'
    : '/api/v1/firebaseServiceProxy';

const MEDIA_SHEET_SERVICE_HOSTS = {
  production: '/api/v1/mediaSheetProxy',
  local: 'http://localhost:8080/api/v1/mediaSheetProxy',
};
const ZAPIER_SERVICE_HOSTS = {
  production: '/api/v1/zapier',
  local: 'http://localhost:8080/api/v1/zapier',
};

const BENCHMARKS_SERVICE_HOSTS = {
  production: '/api/v1/benchmarksService',
  local: 'http://localhost:8080/api/v1/benchmarksService',
};

const DEFAULT_COUNTRY_ISO = 'USA';

const createCachebuster = () => parseInt(Math.random() * 10000, 10);

const s4 = () =>
  Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);

const monthDict = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const dayDifference = date => {
  const firstDate = new Date(date);
  const today = new Date();
  const t1 = firstDate.getTime();
  const t2 = today.getTime();

  return parseInt((t2 - t1) / (24 * 3600 * 1000), 10);
};

const hourDifference = date => {
  const firstDate = new Date(date);
  const today = new Date();
  const t1 = firstDate.getTime();
  const t2 = today.getTime();

  return parseInt((t2 - t1) / (60 * 60 * 1000), 10);
};

const prependScheme = url => {
  if (!/^https?:\/\//i.test(url)) {
    url = 'https://' + url;
  }

  return url;
};

export default {
  DISCOVER_BUNDLES,
  DEFAULT_COUNTRY_ISO,
  createCachebuster,
  multicartUrl(v2, subdomain = '') {
    const subdomainLink = subdomain;
    let url;

    if (subdomainLink) {
      url = prependScheme(subdomainLink);
    } else {
      url = v2
        ? ATTACH_HOSTS.current.productionV2
        : ATTACH_HOSTS.current.production;
    }

    if (!this.isProduction()) {
      url = v2
        ? ATTACH_HOSTS.current.stagingV2
        : ATTACH_HOSTS.current.staging;
    }

    if (this.isLocalHost()) {
      url = ATTACH_HOSTS.current.local;
    }

    return url;
  },
  getBaseUrl(v2, subdomain = '') {
    return this.multicartUrl(v2, subdomain);
  },
  demoUrl(player, platform) {
    const baseUrl = this.getBaseUrl(player.isDiscover);
    const demoParams = `?internalVisualTest=true&cb=${createCachebuster()}`;

    if (platform) {
      return `${baseUrl}/player/${platform}/${player.id}${demoParams}`;
    }

    if (player.isDiscover) {
      return `${baseUrl}/link/${player.id}${demoParams}`;
    }

    return `${baseUrl}/demo/${player.id}${demoParams}`;
  },
  productionAttachUrl(player, isDiscover, subdomain = '') {
    const baseUrl = this.getBaseUrl(isDiscover, subdomain);

    if (isDiscover) {
      return `${baseUrl}/link/{{trackingId}}/${player}?`;
    }

    return `${baseUrl}/{{trackingId}}/${player}?`;
  },
  productServiceUrl() {
    return this.isProduction()
      ? PRODUCT_SERVICE_HOSTS.production
      : PRODUCT_SERVICE_HOSTS.staging;
  },
  productSearchUrl() {
    return this.isProduction()
      ? PRODUCT_SEARCH_HOSTS.production
      : PRODUCT_SEARCH_HOSTS.staging;
  },
  availabilityUrl() {
    return this.isProduction()
      ? AVAILABILITY_URL.production
      : AVAILABILITY_URL.staging;
  },
  guid() {
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  },
  shortRandomId() {
    return s4() + s4();
  },
  isEmptyObject(obj) {
    for (const prop in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }

    return JSON.stringify(obj) === JSON.stringify({});
  },
  sortArrayByDate(array, key) {
    return array.sort(function(a, b) {
      const x = new Date(a[key]);
      const y = new Date(b[key]);

      return x > y ? -1 : x < y ? 1 : 0;
    });
  },
  sortArrayByKey(array, key) {
    return array.sort(function(a, b) {
      const x = b[key].toLowerCase();
      const y = a[key].toLowerCase();

      return x > y ? -1 : x < y ? 1 : 0;
    });
  },
  sortArrayByNumberKey(array, key) {
    return array.sort(function(a, b) {
      const x = Number(a[key]);
      const y = Number(b[key]);

      return Number(x) > Number(y) ? -1 : Number(x) < Number(y) ? 1 : 0;
    });
  },
  sortObjectByKey(object) {
    return Object.keys(object)
      .sort()
      .reduce((r, k) => ((r[k] = object[k]), r), {});
  },
  sortArrayAlphabetically(array) {
    return array.sort((a, b) => {
      if (a.toLowerCase() < b.toLowerCase()) {
        return -1;
      }

      if (a.toLowerCase() > b.toLowerCase()) {
        return 1;
      }

      return 0;
    });
  },
  slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  },
  isProduction() {
    // return process.env.PLATFORM_ENV === 'prod'
    return window.location.hostname === 'platform.mikmak.tv';
  },
  isPreviewChannel() {
    return /^mikmak-platform-development--[a-zA-Z0-9.-]*-[a-zA-Z0-9]{8}.web.app/.test(
      window.location.hostname,
    );
  },
  isDev() {
    return window.location.hostname === 'platform-dev.mikmak.tv';
  },
  getQueryParam(searchKey) {
    let match;
    let queryParams = window.location.search;

    if (queryParams && queryParams[0] == '?') {
      queryParams = queryParams.substring(1);

      const pairArray = queryParams.split('&');

      pairArray.map(pair => {
        const key = pair.split('=')[0];
        const value = pair.split('=')[1];

        if (key == searchKey) {
          match = value;
        }
      });
    }

    return match;
  },
  dayDifference,
  hourDifference,
  numberWithCommas(x) {
    const parts = x.toString().split('.');

    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (parts[1] ? '.' + parts[1] : '')
    );
  },
  toTitleCase(str) {
    return str.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  monthDict,
  isLocalHost() {
    return window.location.host.search('localhost') >= 0;
  },
  isDesktop() {
    let isDesktop = true;

    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4),
      )
    )
      isDesktop = false;

    if (window.navigator.platform == 'MacIntel') isDesktop = true;
    if (window.navigator.platform == 'Windows') isDesktop = true;

    return isDesktop;
  },
  getHostNameFromUrl: (url, keepPath) => {
    if (url.indexOf('://www.') > -1) url = url.split('://www.')[1];
    if (url.indexOf('://www1.') > -1) url = url.split('://www1.')[1];
    if (url.indexOf('://store.') > -1) url = url.split('://store.')[1];
    if (url.indexOf('://shop.') > -1) url = url.split('://shop.')[1];
    if (url.indexOf('://m.') > -1) url = url.split('://m.')[1];
    if (url.indexOf('://') > -1) url = url.split('://')[1];
    if (url.indexOf('goto.walmart') > -1) url = url.split('goto.')[1];
    if (url.indexOf('direct.sharkclean') > -1) url = url.split('direct.')[1];
    if (url.indexOf('direct.ninjakitchen') > -1) url = url.split('direct.')[1];
    if (url.indexOf('beauty.shoppersdrugmart') > -1)
      url = url.split('beauty.')[1];
    url = url.split('?')[0];

    if (!keepPath) {
      url = url.split('/')[0];
    }

    return url;
  },
  async callProductService(endpoint) {
    return this.getCallService(this.productServiceUrl(), endpoint);
  },
  async postCallProductSearch(path, data) {
    return this.postCallService(this.productSearchUrl(), path, data);
  },
  async postCallProductService(path, data) {
    return this.postCallService(this.productServiceUrl(), path, data);
  },
  async getCallVIPService(endpoint) {
    return this.getCallService(this.availabilityUrl(), endpoint);
  },
  async postCallVIPService(path, data) {
    return this.postCallService(this.availabilityUrl(), path, data);
  },
  async getCallService(host, endpoint) {
    return await $.ajax({
      url: `${host}/${endpoint}`,
      type: 'GET',
      success: function() {},
      error: function() {},
    });
  },
  async postCallService(host, path, data) {
    const response = await $.ajax({
      url: `${host}/${path}`,
      contentType: 'application/json;charset=utf-8',
      type: 'POST',
      data: JSON.stringify(data),
      success: function() {},
      error: function(xhr, desc, err) {
        return {
          success: false,
          message: err.message || 'Network request failed',
        };
      },
    });

    return response;
  },
  async postToMikMakFirebaseService(path, data, token) {
    await $.ajax({
      url: `${firebaseProxyUrl}/${path}`,
      contentType: 'application/json',
      type: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      data: JSON.stringify(data),
      success: function() {},
      error: function() {},
    });
  },
  // this post is designed to send all relevant info to embed upon save of a product, view, or brand
  // embed will then flush all redis keys associated with the info sent through
  // and the changes made to a product, view, or brand will be immediately apparent
  // without needing to use internalVisualTest=true as a query param in the embed url
  async flushEmbedCache(dataToFlush) {
    // no need to flush the cache if running locally
    if (this.isLocalHost()) return;

    const embedUrl = this.embedUrl();

    await $.ajax({
      url: `${embedUrl}/7f9s0d0a/flushCache`,
      contentType: 'application/json',
      type: 'POST',
      headers: {},
      data: JSON.stringify(dataToFlush),
      success: function() {},
      error: function(message) {
        // throws the error to be caught in the catch of the component calling
        throw new Error(`Problem flushing the cache in embed: ${message}`);
      },
    });
  },
  async getFromMikMakFirebaseService(path = '', token) {
    // Override to make a direct call to firebase service because these calls return large
    // responses that get blocked by cloud proxy.
    const requestUrl = (path.includes('/retailerCarts') || path.includes('/brandProductFeed') || path.includes('getBrandProductFeed/'))
      ? this.firebaseServiceUrl()
      : firebaseProxyUrl;

    const response = await $.ajax({
      url: `${requestUrl}/${path}`,
      type: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      success: function() {},
      error: function(xhr, desc, err) {
        eventDispatcher('getFromFirebaseServiceError', {
          xhr,
          desc,
          err,
          path,
        });
      },
    });

    return response;
  },
  async queryFirebaseServiceByKeyValue(table, key, value, token) {
    const response = await $.ajax({
      url: `${firebaseProxyUrl}/getByChild/${table}/${key}/${value}`,
      type: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      success: function() {},
      error: function() {},
    });

    return response;
  },
  hexToRgba: (color = '', opacity) =>
    `rgba(${color
      .replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (m, r, g, b) => '#' + r + r + g + g + b + b,
      )
      .substring(1)
      .match(/.{2}/g)
      .map(x => parseInt(x, 16))
      .join(', ')}, ${opacity || 1})`,
  rgbaToHex: (color = '') => {
    const [r, g, b] = color.replace(/rgba\(|\)|\s/g, '').split(',');

    return `#${((1 << 24) + (Number(r) << 16) + (Number(g) << 8) + Number(b))
      .toString(16)
      .slice(1)}`;
  },
  capitalize(str) {
    if (typeof str !== 'string') return '';
    const firstLetter = str.charAt(0).toUpperCase();

    return `${firstLetter}${str.slice(1)}`;
  },
  cleanUrl(url) {
    url = decodeURIComponent(url) || url;
    url = url.split('?')[0];
    url = url.split('#')[0];
    // replace trailing slash
    url = url.replace(/\/$/, '');
    // remove scheme
    url = url.replace(/http(s)*:\/\//, '');
    // remove any leading www. domains since www.brand.com should be the same as brand.com
    url = url.replace(/^www./, '');

    return url;
  },
  formatProdViewUrl(url, scriptVersion) {
    if (!url) return '';

    url = this.cleanUrl(url);

    const { V1, V2 } = DISCOVER_BUNDLES;

    // chop off subdomains for older bundles
    if (scriptVersion !== V1 && scriptVersion !== V2) {
      const urlSegments = url.split('/');
      // take everything left of the first / and break down by domains
      const urlDomains = urlSegments[0].split('.');
      const domainIndex = urlDomains.length - 2;

      // Ignore subdomains, only take domain.end
      url = urlDomains.slice(domainIndex).join('.');

      // If there were url parts to the right of the last / add them back in
      if (urlSegments.length > 1) {
        url = `${url}/${urlSegments.slice(1).join('/')}`;
      }
    }

    return url;
  },
  formatStagingViewUrl(url, brandId) {
    if (!url) return '';
    if (!brandId)
      throw new Error('Brand ID missing - cannot format staging view url');

    const cleanedUrl = this.cleanUrl(url);
    const pathMatches = cleanedUrl.match(/\/.*$/); // get everything after remaining /

    if (pathMatches && pathMatches.length) {
      return `${brandId}${pathMatches[0]}`;
    }

    return brandId;
  },
  formatBrandDiscoverDomains(brand = {}) {
    const brandDiscoverSettings = brand.embed || {};
    const {
      scriptVersion,
      productionDomains = [],
      stagingDomains = [],
    } = brandDiscoverSettings;

    return [...productionDomains, ...stagingDomains].map(domain =>
      this.formatProdViewUrl(domain, scriptVersion),
    );
  },
  domainRegExp: new RegExp(/(([a-z0-9]+(-+[a-z0-9]+)*\.)+[a-z]{2,})/),
  domainRegExpWithScheme: new RegExp(
    /^(https?:\/\/)?([a-z0-9]+(-+[a-z0-9]+)*\.)+[a-z]{2,}$/,
  ),
  extractDomainFromUrl(url) {
    const domain = url.match(this.domainRegExp);

    return domain ? domain[0] : null;
  },
  validateDiscoverViewPdpUrl(url, scriptVersion, brandDomains, views) {
    if (!url) return;

    try {
      decodeURIComponent(url);
    } catch (e) {
      return 'Invalid URL format';
    }

    // if formatted inputted URL matches any exisiting View's formatted pdpUrl show error
    if (views.indexOf(url) > -1) {
      return 'There is already a View assigned to this site URL.';
    }

    // If there are staging and production domains
    // check that inputed URL domain matches one of these domains.
    // If not, ask user to add these domains in Settings.
    if (scriptVersion === DISCOVER_BUNDLES.V1) {
      const pdpUrlDomain = this.extractDomainFromUrl(url);

      if (brandDomains.indexOf(pdpUrlDomain) === -1) {
        return 'Cannot save View with unknown Site URL domain. Ensure your settings reflect the domains you wish to use Discover on.';
      }
    }
  },
  convertModifiedDateToText: modDate => {
    const dayCount = dayDifference(modDate);
    const hourCount = hourDifference(modDate);
    let timeString;

    if (dayCount > 30) {
      const d = new Date(modDate);
      const y = d.getFullYear();
      const m = monthDict[d.getMonth()];

      timeString = `in ${m} of ${y}`;
    }

    if (dayCount <= 30 && dayCount > 1) timeString = `${dayCount} days ago`;
    if (dayCount == 1) timeString = `yesterday`;

    if (dayCount == 0) {
      timeString = `${hourCount} hours ago`;
      if (hourCount == 1) timeString = `1 hour ago`;
      if (hourCount < 1) timeString = `just now`;
    }

    return `Last updated ${timeString}`;
  },
  formatDateWithHour: date => {
    // formats date as May 29, 1453, 12:00 AM
    return format(new Date(date), 'PPp');
  },
  formatDateAsMonthDayYear: date => {
    // formats date as 01/31/2021
    return format(new Date(date), 'MM/dd/yyyy');
  },
  firebaseServiceUrl() {
    // If developing Firebase Service locally, temporarily override this function to return
    // the local url defined in `FIREBASE_SERVICE_HOSTS` same for testing a feature deploy
    // of firebase service.
    if (this.isProduction()) {
      return FIREBASE_SERVICE_HOSTS.production;
    } else {
      return FIREBASE_SERVICE_HOSTS.development;
    }
  },
  embedUrl() {
    if (this.isProduction()) {
      return EMBED_HOSTS.current.production;
    } else {
      return EMBED_HOSTS.current.development;
    }
  },
  getCurrentWindowDuration() {
    // Returns the amount of milliseconds elapsed for a given document
    // This might not always reset to 0 when navigating pages in SPA
    if (!window || !window.performance) return 0;

    return window.performance.now();
  },
  getEnvironmentName() {
    switch (true) {
      case this.isPreviewChannel():
        return 'preview';
      case this.isDev():
        return 'development';
      case this.isProduction():
        return 'production';
      case this.isLocalHost():
        return 'local';
      default:
        return undefined;
    }
  },
  reverseDict(dictionary) {
    const finalObj = {};

    Object.keys(dictionary).forEach(key => {
      finalObj[dictionary[key]] = key;
    });

    return finalObj;
  },
  arrayDiff(arr1, arr2) {
    return arr1.filter(x => !arr2.includes(x));
  },
  getFormattedProfileName(profileName) {
    const regexPattern = /\w*:\s*(.*\s*-?\s*\w*)/;
    const formattedProfileName = regexPattern.exec(profileName) || profileName;

    if (Array.isArray(formattedProfileName)) {
      return `${regexPattern
        .exec(profileName)[1]
        .replace('-', '')
        .trim()}`;
    }

    return formattedProfileName;
  },
  arraysMatchNoOrder(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    const sortedArr1 = arr1.concat().sort();
    const sortedArr2 = arr2.concat().sort();

    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;
  },
  arraysMatchWithWildcard(arr1, arr2, wildcard) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    return arr1.every((value, index) => {
      if (value.startsWith(wildcard) || arr2[index].startsWith(wildcard)) return true;

      return value === arr2[index];
    });
  },
  mediaSheetServiceUrl() {
    return this.isLocalHost()
      ? MEDIA_SHEET_SERVICE_HOSTS.local
      : MEDIA_SHEET_SERVICE_HOSTS.production;
  },
  getMediaSheetInvalidType(message) {
    if (!message) return 'There is an invalid type in the row. Please review the row to fix.';
    if (!message.includes('#')) return message;

    const [ , typeError] = message.split('#');
    const { name }  = dataIdSvcErrorDict[typeError];

    return `Invalid ${name}`;
  },
  removeQuestionMark(message) {
    return message.replace('?', '');
  },
  zapierServiceUrl() {
    return this.isLocalHost()
      ? ZAPIER_SERVICE_HOSTS.local
      : ZAPIER_SERVICE_HOSTS.production;
  },
  benchmarksServiceUrl() {
    return this.isLocalHost()
      ? BENCHMARKS_SERVICE_HOSTS.local
      : BENCHMARKS_SERVICE_HOSTS.production;
  },
  salesDataServiceUrl() {
    return this.isLocalHost()
      ? SALES_DATA_SERVICE_URL.local
      : SALES_DATA_SERVICE_URL.production;
  },
  isValidUrl(url = '') {
    // eslint-disable-next-line max-len
    const validUrlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/ig;

    return validUrlRegex.test(url);
  },
  isValidPrice(value = '') {
    const validPriceRegex = /^[0-9]+\.[0-9]{2}$/;  // two decimal places

    return validPriceRegex.test(value);
  },
};
